import { podcastPublicSlug } from "../podcast-links";

export type PeriodicalDeepLink = {
  issueId: string;
  articleId: string | null;
};

export function periodicalDeepLink(search: string): PeriodicalDeepLink | null {
  const params = new URLSearchParams(search);
  const issueId = params.get("issue")?.trim() ?? "";
  const articleId = params.get("article")?.trim() || null;
  if (issueId.length === 0 || issueId.length > 100) return null;
  if (articleId && articleId.length > 64) return null;
  return { issueId, articleId };
}

export function podcastDeepLink(pathname: string, search: string): string | null {
  const pathMatch = pathname.match(/^\/podcasts\/([^/]+)\/?$/u);
  let episodeId = "";
  if (pathMatch) {
    try {
      episodeId = decodeURIComponent(pathMatch[1]).trim();
    } catch {
      return null;
    }
  } else {
    episodeId = new URLSearchParams(search).get("podcast")?.trim() ?? "";
  }
  if (episodeId.length === 0 || episodeId.length > 100) return null;
  return podcastPublicSlug(
    episodeId,
    episodeId.startsWith("bidclub-") ? "BidClub" : null,
  );
}
